import styled from 'styled-components'

export const Icon = styled.span`
  display: flex;
  height: ${(props) => props.size + 'px'};
  width: ${(props) => props.size + 'px'};
  color: ${(props) => props.color};
  font-size: ${(props) => props.size + 'px'};
`
